export default "__VITE_ASSET__BYplIm_Q__"